import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=9ccdf9a4&"
import script from "./index2.vue?vue&type=script&lang=coffee&"
export * from "./index2.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports